import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@fiverr-private/fit';
import GetThumbnail from '../GetThumbnail';
import * as FilerrsSelectors from '../../selectors/filerrs';

import './style.scss';

const Thumbnail = ({ fileName, thumbUrl, children, previewType }) => (
    <section className="thumbnail-wrapper">
        <div className="img-container">
            { children }
            <GetThumbnail previewType={previewType} thumbnail={thumbUrl}/>
        </div>
        <Tooltip content={fileName} delay={true} className="file-name">
            {fileName}
        </Tooltip>
    </section>
);

Thumbnail.propTypes = {
    previewType: PropTypes.string,
    thumbUrl: PropTypes.string,
    fileName: PropTypes.string,
    children: PropTypes.any
};

const mapStateToProps = (state, { filerrId }) => ({
    thumbUrl: FilerrsSelectors.getThumbUrlById(state, filerrId),
    previewType: FilerrsSelectors.getPreviewTypeById(state, filerrId),
    fileName: FilerrsSelectors.getFileNameById(state, filerrId)
});

export default connect(mapStateToProps)(Thumbnail);
